import React, { useState, useEffect } from "react";
import { StyleSheet, css } from "aphrodite/no-important";
import Table from "./TableActivity_models";
import ModelButton from "./ModelButton";
import { useHistory } from "react-router-dom";
import axios from "axios";
import "./style.css";

const styles = StyleSheet.create({
  h1: {
    fontSize: "7.5em",
    margin: "15px 0px",
    fontWeight: "bold",
  },
  h2: {
    fontWeight: "bold",
  },
});

const Models = () => {
  const history = useHistory();
  const [isFormValid, setIsFormValid] = useState(false);
  const [codeName, setCodeName] = useState("");
  const [name, setName] = useState("");
  const [sum, setSum] = useState("");
  const [paymentSystem, setPaymentSystem] = useState("");
  const [paymentDetail, setPaymentDetail] = useState("");
  const [status, setStatus] = useState("");
  const [note, setNote] = useState("");
  const [comment, setComment] = useState(""); // New state for Comment input

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          "https://golive.mobi/api/user/m-billing/detail/",
          { id: localStorage.getItem("billingcheck") },
          {
            headers: {
              Authorization: "Token 978f3467a8cbdf3451d1a032d9e03cd8e376e32d",
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 200) {
          const responseData = response.data;
          setName(responseData.name);
          setSum(responseData.balance_good);
          setPaymentSystem(responseData.payment_system);
          setPaymentDetail(responseData.payment_detail);
          setStatus(responseData.billing_status);
          setNote(responseData.billing_note);
          document.title = `${responseData.name}, ${responseData.age}`;
        } else {
          console.error("Error:", response);
          // Handle error response
        }
      } catch (error) {
        console.error("Error:", error);
        // Handle error
      }
    };

    fetchData();
  }, []);

  const handleInputChange = () => {
    const nameValue = document.querySelector(".square_field1").value;
    const sumValue = document.querySelector(".square_field2").value;
    const paymentSystemValue = document.querySelector(".square_field3").value;
    const paymentDetailValue = document.querySelector(".square_field4").value;
    const statusValue = document.querySelector(".square_field5").value;
    const noteValue = document.querySelector(".square_field6").value;
    const commentValue = document.querySelector(".square_field7").value; // New input for Comment

    setIsFormValid(
      nameValue !== "" &&
      sumValue !== "" &&
      paymentSystemValue !== "" &&
      paymentDetailValue !== "" &&
      statusValue !== "" &&
      noteValue !== "" &&
      commentValue !== "" // Check if Comment is not empty
    );
  };

  const handleClick = async (e) => {
    e.preventDefault();

    const data = {
      id: localStorage.getItem("billingcheck"),
      note: note,
      comment: comment, // Include the Comment in the data object
    };

    try {
      const response = await axios.post(
        "https://golive.mobi/api/user/m-billing/payment/add/",
        data,
        {
          headers: {
            Authorization: "Token 978f3467a8cbdf3451d1a032d9e03cd8e376e32d",
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        history.push("/billing");
      } else {
        console.error("Error:", response);
        // Handle error response
      }
    } catch (error) {
      console.error("Error:", error);
      // Handle error
    }
  };

  const [paymentHistory, setPaymentHistory] = useState([]);

  useEffect(() => {
    const fetchPaymentHistory = async () => {
      try {
        const response = await axios.post(
          "https://golive.mobi/api/user/m-billing/payment/list/",
          { id: localStorage.getItem("billingcheck") },
          {
            headers: {
              Authorization: "Token 978f3467a8cbdf3451d1a032d9e03cd8e376e32d",
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 200) {
          const responseData = response.data;
          setPaymentHistory(responseData);
        } else {
          console.error("Error:", response);
          // Handle error response
        }
      } catch (error) {
        console.error("Error:", error);
        // Handle error
      }
    };

    fetchPaymentHistory();
  }, []);

  return (
    <div>
      <h2 style={{ marginLeft: "1%", fontFamily: "Inter" }}>
        Payment
      </h2>

      <div className="square" style={{ height: 'auto'}}>
        <form className="createmodel" style={{ fontSize: '12px'}}><br /><br /><br />
          <label style={{ marginLeft: '10%', fontFamily: 'Noto Sans Mono'}}>
            Name:
            <span style={{ marginLeft: '15%'}}>{name}</span>
          </label>
          <br /><br /><br />
          <label style={{ marginLeft: '10%', fontFamily: 'Noto Sans Mono'}}>
            Sum:
            <span style={{ marginLeft: '16%'}}>{sum}</span>
          </label>
          <br /><br /><br />
          <label style={{ marginLeft: '10%', fontFamily: 'Noto Sans Mono'}}>
            Payment system:
            <span style={{ marginLeft: '4%'}}>{paymentSystem}</span>
          </label>
          <br /><br /><br />
          <label style={{ marginLeft: '10%', fontFamily: 'Noto Sans Mono'}}>
            Payment detail:
            <span style={{ marginLeft: '4%'}}>{paymentDetail}</span>
          </label>
          <br />
          <label style={{ marginLeft: '10%'}}>
            Note:
            <input
             style={{ marginLeft: '16.5%'}}
              type="text"
              className="square_field6"
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />
          </label>
          <br />
          <label style={{ marginLeft: "10%" }}>
        Comment:
        <input
          style={{ marginLeft: "12%" }}
          type="text"
          className="square_field6" // Class for the Comment input
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />
      </label>
      <br />
      <button
        type="submit"
        onClick={handleClick}
        className={`square_button`}
        
      >
        Save
      </button>
        </form>
<br /><br />
<hr style={{ border: '1px solid rgba(0, 0, 0, 0.05)', marginTop: '2%', marginBottom: '2%' }} />
<br />
        <h2 style={{ marginLeft: "5%", fontFamily: "Inter", fontSize: '15px' }}>
        Payment history
      </h2>
      <br />

      <table className="table">
          <thead style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.07)' }}>
            <tr>
              <th style={{
                  color: 'black',
                  fontFamily: 'Noto Sans Mono',
                  fontWeight: '500',
                  fontSize: '12px',
                  textAlign: 'right',
                }}>Amount</th>
              <th style={{
                  color: 'black',
                  fontFamily: 'Noto Sans Mono',
                  fontWeight: '500',
                  fontSize: '12px',
                  textAlign: 'right',
                }}>Date</th>
              <th style={{
                  color: 'black',
                  fontFamily: 'Noto Sans Mono',
                  fontWeight: '500',
                  fontSize: '12px',
                  textAlign: 'right',
                }}>Note</th>
              <th style={{
                  color: 'black',
                  fontFamily: 'Noto Sans Mono',
                  fontWeight: '500',
                  fontSize: '12px',
                  textAlign: 'right',
                }}>Comment</th>
            </tr>
          </thead>
          <tbody>
            {paymentHistory.map((item, index) => (
              <tr key={index} className={`${index % 2 === 0 ? 'even-row' : 'odd-row'} ${
                item.selected ? 'selected-row' : 'non-selected-row'
              }`}>
                <td
                  style={{
                    color: item.selected ? '#6D33FF' : '#606C80',
                    fontFamily: 'Noto Sans Mono',
                    fontWeight: '400',
                    fontSize: '12px',
                    textAlign: 'right',
                  }}>{item.amount}</td>
                <td
                  style={{
                    color: item.selected ? '#6D33FF' : '#606C80',
                    fontFamily: 'Noto Sans Mono',
                    fontWeight: '400',
                    fontSize: '12px',
                    textAlign: 'right',
                  }}>{new Date(item.date * 1000).toLocaleString()}</td>
                <td
                  style={{
                    color: item.selected ? '#6D33FF' : '#606C80',
                    fontFamily: 'Noto Sans Mono',
                    fontWeight: '400',
                    fontSize: '12px',
                    textAlign: 'right',
                  }}>{item.note}</td>
                <td
                  style={{
                    color: item.selected ? '#6D33FF' : '#606C80',
                    fontFamily: 'Noto Sans Mono',
                    fontWeight: '400',
                    fontSize: '12px',
                    textAlign: 'right',
                  }}>{item.comment}</td>
              </tr>
            ))}
          </tbody>
        </table>
<br />

      </div>
      <br />
    </div>
  );
};

export default Models;
